module.exports = __webpack_public_path__ + "2ed7cd6cafd7fa16d7715e274f6111be.png";